/**
 * Generates a key suffix by converting the input value to lowercase and replacing spaces with dashes.
 *
 * @param {string} value - The input string to be processed.
 * @param {string} type - The type to be appended at the end of the processed value.
 * @returns {string} - The generated key suffix in the format: 'processed-value--type'.
 */
export const getKeySuffix = (value: string, type: string) => {
  return `${value.toLowerCase().split(" ").join("-")}--${type}`;
};
